import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import SupplierListModal from "../components/dcSupplierModal";
import ItemListModalDc from "../components/itemListModalDc";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, useParams, Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddDc = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [priorNo, setPriorNo] = useState('');
  const [formData, setFormData] = useState({PoNo: "", indentNo: "", remarks: "", department: "" });
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();

  const canEntry = hasPermission("Delivery challan", "entry");


  useEffect(() => {
  const fetchPriorNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dc_no?branch=${branch}`);
      if (response.data.PoNo) {
        console.log(response.data.PoNo);
        
        const newPrNo = parseInt(response.data.PoNo, 10) || 0;
        setPriorNo(newPrNo.toString());
        setFormData(prevState => ({ ...prevState, PoNo: newPrNo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPriorNo();
}, [branch]);

useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_branches`);
        setBranches(response.data.branches || []);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, []);


  const handleSelectItem = (item) => {
    setSelectedItems((prevItems) => [
      ...prevItems,
      { ...item, vcode: "", vnumber: "", qty: "", duedate: "" },
    ]);
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRowChange = (index, field, value) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleVehicleSelect = (supplier) => {
    if (!supplier || !supplier.supplierMaster_code || !supplier.supplierMaster_name) {
      console.error("Supplier selection error: Missing required data");
      return;
    }
  
    console.log("Selected Supplier:", supplier);
  
    // Update formData with all required supplier details
    setFormData((prevData) => ({
      ...prevData,
      supplierCode: supplier.supplierMaster_code,
      supplierName: supplier.supplierMaster_name,
      address1: supplier.supplierMaster_addressline1,
      address2: supplier.supplierMaster_addressline2,
      city: supplier.supplierMaster_city,
      pincode: supplier.supplierMaster_pincode,
      phone: supplier.supplierMaster_phoneNumber,
      email: supplier.supplierMaster_email,
    }));
  
    setShowVehicleModal(false);
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  // Function to submit the form data
  const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Basic Header Validations
  if (!formData.PoNo?.trim()) {
    Swal.fire("Error", "PO/DC No is required", "error");
    return;
  }
  if (!formData.supplierCode?.trim()) {
    Swal.fire("Error", "Supplier Code is required", "error");
    return;
  }
  if (!formData.supplierName?.trim()) {
    Swal.fire("Error", "Supplier Name is required", "error");
    return;
  }
  if (!formData.type?.trim()) {
    Swal.fire("Error", "Type is required", "error");
    return;
  }
 // Example for validating Reference Number as numeric
if (!formData.refNo?.trim()) {
  Swal.fire("Error", "Reference No is required", "error");
  return;
} else if (!/^\d+$/.test(formData.refNo)) {
  Swal.fire("Error", "Reference No must be numeric only", "error");
  return;
}

  if (!formData.refDate?.trim()) {
    Swal.fire("Error", "Reference Date is required", "error");
    return;
  }
  if (!formData.vno?.trim()) {
    Swal.fire("Error", "Vehicle No is required", "error");
    return;
  }

  // ✅ Contact Info Validation
  if (!formData.address1?.trim()) {
    Swal.fire("Error", "Address is required", "error");
    return;
  }
  if (!formData.city?.trim()) {
    Swal.fire("Error", "City is required", "error");
    return;
  }
  if (!/^\d{6}$/.test(formData.pincode)) {
    Swal.fire("Error", "Valid 6-digit Pincode is required", "error");
    return;
  }
  if (!/^\d{10}$/.test(formData.phone)) {
    Swal.fire("Error", "Valid 10-digit Phone Number is required", "error");
    return;
  }
  if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    Swal.fire("Error", "Invalid Email format", "error");
    return;
  }

  // ✅ Item List Validation
  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

for (let i = 0; i < selectedItems.length; i++) {
  const item = selectedItems[i];
  const qty = Number(item.qty);
  const closingStock = Number(item.itemMaster_rejStock);

  // 🔹 Item code check
  if (!item.itemmaster_code) {
    Swal.fire("Error", `Item code is missing for item #${i + 1}`, "error");
    return;
  }

  // 🔹 Quantity validation
  if (!qty || isNaN(qty) || qty <= 0) {
    Swal.fire("Error", `Please enter a valid quantity greater than 0 for item #${i + 1}`, "error");
    return;
  }

    // 🔹 Stock availability validation
  if (closingStock === 0) {
    Swal.fire("Error", `No stock available for item #${i + 1}`, "error");
    return;
  }

  if (qty > closingStock) {
    Swal.fire(
      "Error",
      `Quantity for item #${i + 1} (${qty}) cannot exceed available stock (${Math.trunc(closingStock)}).`,
      "error"
    );
    return;
  }

  // 🔹 Due date check
  if (!item.duedate) {
    Swal.fire("Error", `Due date is required for item #${i + 1}`, "error");
    return;
  }


}



const payload = {
  branch: branch,
  user: userId,
  dcNo: formData.PoNo,
  supplierCode: formData.supplierCode,
  supplierName: formData.supplierName,
  type: formData.type,
  refNo: formData.refNo,
  refDate: formData.refDate,
  vno: formData.vno,
  pack: formData.pack,
  remarks: formData.remarks,
  address: formData.address1,
  city: formData.city,
  pincode: formData.pincode,
  phone: formData.phone,
  email: formData.email,
  items: selectedItems.map((item) => ({
    itemCode: item.itemmaster_code,
    itemName: item.itemmaster_name,
    itemUom: item.itemmaster_uom,
    qty: item.qty,
    duedate: item.duedate,
    ref: item.csp,
  })),
};

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/dc_insert",
      payload
    );

    Swal.fire("Success", "Delivery Challan added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/dcView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};

  if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                    <h2 className="add-txt">Delivery Challan - Add</h2>
                    <Link to='/inventory/dcView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>D.C No :</label>
                <input 
  type="text" 
  name="indentNo" 
  value={formData.PoNo}  // Use "PoNo" instead of "newPrNo"
  onChange={handleChange} 
/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs"value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Type :</label>
                <select name="type" value={formData.type} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Returnable">Returnable</option>
                  <option value="Non-Returnable">Non-Returnable</option>
                  <option value="Purchase-Rejection">Purchase Rejection</option>
                  <option value="Customer-Properties">Customer Properties</option>
                 
                </select>
              </div>
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="branch" value={branch} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="supplier" value={formData.supplierCode || ""} readOnly onClick={() => setShowVehicleModal(true)} placeholder="Select Supplier"/>
              </div>

              <div className="form-group">
                <label>Supplier Name:</label>
                <input type="text" name="supplierName" value={formData.supplierName || ""} readOnly />
              </div>
            </div>




            <div className="form-row">
              <div className="form-group">
                <label>Your Ref No :</label>
                <input type="text" name="refNo" value={formData.refNo} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>Your Ref Date :</label>
                <input type="date" name="refDate" value={formData.refDate} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle No :</label>
                <input type="text" name="vno" value={formData.vno} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>No.Of Packs:</label>
                <input type="text" name="pack" value={formData.pack} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={formData.address1 || ""} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>Address 2:</label>
                <input type="text" name="address2" value={formData.address2 || ""} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={formData.city || ""} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>Pincode :</label>
                <input type="text" name="pincode" value={formData.pincode || ""} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone :</label>
                <input type="text" name="phone" value={formData.phone || ""} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>E-mail :</label>
                <input type="text" name="email" value={formData.email || ""} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks || ""} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label></label>
                <input type="hidden"/>
              </div>
            </div>


            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Rejected Stock</th>
                    <th>D.C Qty</th>
                    <th>Due Date</th>
                    <th>CSP/Ref.</th>
                    <th>Del</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemmaster_code}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td>{Math.trunc(item.itemMaster_rejStock)}</td>
                        <td>
                          <input
                            type="text"
                            value={item.qty}
                            onChange={(e) => handleRowChange(index, "qty", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            value={item.duedate}
                            onChange={(e) => handleRowChange(index, "duedate", e.target.value)}
                          />
                        </td>
                      
                        <td>
                          <input
                            type="text"
                            value={item.csp}
                            onChange={(e) => handleRowChange(index, "csp", e.target.value)}
                          />
                        </td>
                        <td className="del">
                          <i className="fa-solid fa-trash-can" onClick={() => handleDeleteRow(index)}></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>
      <ItemListModalDc showModal={showModal} closeModal={() => setShowModal(false)} onSelectItem={handleSelectItem} branch={branch} />
      <SupplierListModal showModal={showVehicleModal} closeModal={() => setShowVehicleModal(false)} onSelectVehicle={handleVehicleSelect} branch={branch} 
      />
    </div>
  );
};

export default AddDc;
